import React, { useState } from 'react';

import sIcon from '../../../images/icon/flower-icon-blue.svg';
import Bg from '../../../images/bg/da-service_bg.jpg';

import icon1 from '../../../images/icon/da-fea_icon01.svg';
import icon2 from '../../../images/icon/da-fea_icon02.svg';
import icon3 from '../../../images/icon/da-fea_icon03.svg';
import icon4 from '../../../images/icon/da-fea_icon04.svg';

/* ARO Events – What We Do / Value Areas */
const Services = [
  {
    title: 'Industry-Focused Conferences',
    description:
      'We design and deliver B2B conferences that bring together industry leaders, decision-makers, and innovators around the topics shaping the future.',
    sIcon: icon1,
    slug: 'industry-focused-conferences',
  },
  {
    title: 'High-Value Networking',
    description:
      'Our events create structured opportunities for meaningful connections between corporations, investors, and public-sector leaders.',
    sIcon: icon2,
    slug: 'high-value-networking',
  },
  {
    title: 'Brand Visibility & Sponsorship',
    description:
      'We help brands maximise visibility and engagement through carefully curated sponsorship opportunities and targeted exposure.',
    sIcon: icon3,
    slug: 'brand-visibility-sponsorship',
  },
  {
    title: 'Collaboration & Innovation Platforms',
    description:
      'ARO Events provides future-focused platforms where ideas are exchanged, partnerships are formed, and innovation is accelerated.',
    sIcon: icon4,
    slug: 'collaboration-innovation',
  },
];

const ServiceSection = () => {


  const [activeIndex, setActiveIndex] = useState(1);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  return (
    <section
      className="service pb-150 bg_img"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        
        {/* Section Header */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="da-sec-titlte text-center mb-30">
              <span className="sub_title">
                <span>
                  <img src={sIcon} alt="" />
                </span>
                What We Do
              </span>
              <h2 className="title">
                Creating impactful conferences that connect leaders and drive growth
              </h2>
              <p className="content">
                ARO Events designs high-impact B2B conferences and platforms that
                foster collaboration, visibility, and innovation across industries.
              </p>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="da-service-wrapper">
          {Services.map((service, index) => (
            <div
              key={index}
              className={`da-service-item xb-mouseenter ${
                activeIndex === index ? 'active' : ''
              }`}
              data-wow-delay={`${index * 150}ms`}
              data-wow-duration="600ms"
              onMouseEnter={() => handleMouseEnter(index)}
            >
              <div className="xb-item--holder">
                <div className="xb-item--icon">
                  <img src={service.sIcon} alt="" />
                </div>
                <h3 className="xb-item--title">{service.title}</h3>
                <span className="xb-item--arrow">
                  <i className="fal fa-long-arrow-right"></i>
                </span>
                <p className="xb-item--content">{service.description}</p>
              </div>

             
            </div>
          ))}
        </div>

        

      </div>
    </section>
  );
};

export default ServiceSection;
